import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import {
  DetailInfoComponentModel,
  Accumulative,
} from "../../models/components.model";
import Grid from "@mui/material/Grid";
import DocumentInfoComponentSingle from "./documentInfoComponentSingle";
import NoImageFoundDocument from "../thumbnail/noImageFoundDocument";

export default function DetailInfoComponent({
  sections,
  data,
  documentInfo,
  marginRight,
  marginLeft,
  showFooter,
  showDoc,
}: DetailInfoComponentModel) {
  let document;
  let accumulative;
  let compareHistory: boolean;
  accumulative = {} as Accumulative;

  if (documentInfo != undefined) {
    if (documentInfo?.fileUrl != undefined) {
      document = documentInfo;
    }
    if (
      (documentInfo[0]?.fileUrl != undefined ||
        documentInfo[1]?.fileUrl != undefined) &&
      documentInfo.length > 0
    ) {
      document = documentInfo;
    }
  }
  if (data != undefined) {
    accumulative.accumulativeAmount = data.accumulativeAmount;
    accumulative.inquiryAmount = data.inquiryAmount;
    accumulative.isAccumulative = data.isAccumulative;
    data.dueDatePersian! != data.inquiryDueDatePersian! &&
    data.inquiryDueDatePersian!
      ? (compareHistory = true)
      : (compareHistory = false);
  }
  const [detailSections, setDetailSections] = useState(sections);
  useEffect(() => {
    setDetailSections(sections);
  }, [sections]);
  const [detailData, setDetailData] = useState(data);
  useEffect(() => {
    setDetailData(data);
  }, [data]);

  return (
    // <div className="row mTop20">
    <>
      <div>
        <Grid
          container
          xs={12}
          spacing={{ xs: 1, md: 2 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
          style={{ marginTop: "2vh", marginRight: "3vh" }}
        >
          <Grid container xs={9} columns={{ xs: 4, sm: 8, md: 12 }} spacing={1}>
            {detailSections.map((section) => {
              let value = detailData && detailData[section.dataKey!];
              if (section.dataKey == "serialNo") {
                // const seriTest = detailData[section.dataKey!];
              }

              if (value && section.hasThousandSeparatorFormat) {
                value = value.toLocaleString("fa");
              }
              return (
                <Grid
                  className="confirm"
                  item
                  xs={section.rowCol}
                  sm={12}
                  md={section.rowCol}
                  id="detailInfo"
                  style={{ marginTop: "2vh", whiteSpace: "nowrap" }}
                >
                  <Typography className="divRequestDetailInExpert ">
                    <span className="subColor">{section.title}:&nbsp; </span>
                    <span
                      className="fontBlueColor textFont14 fontWeight"
                      style={
                        section.dataKey == "inquiryDueDatePersian" &&
                        compareHistory == true
                          ? {
                              backgroundColor: "#ee9d01",
                              color: "#fff",
                              borderRadius: "5px",
                              paddingRight: "5px",
                              paddingLeft: "5px",
                            }
                          : section.dataKey == "inquiryDueDatePersian" &&
                            compareHistory == false &&
                            value!
                          ? {
                              backgroundColor: "#28a745",
                              color: "#fff",
                              borderRadius: "5px",
                              paddingRight: "5px",
                              paddingLeft: "5px",
                            }
                          : section.dataKey == "acceptDate_Persian" && value!
                          ? {
                              backgroundColor: "#28a745",
                              color: "#fff",
                              borderRadius: "5px",
                              paddingRight: "5px",
                              paddingLeft: "5px",
                            }
                          : { backgroundColor: "#fff" }
                      }
                    >
                      {(section.dataKey === "estimatedPrice" ||
                        section.dataKey === "acceptDate_Persian") &&
                      (value == null || value === undefined) ? (
                        "..."
                      ) : (
                        <>
                          {section.dataKey === "inquiryReasonTitle" &&
                            value &&
                            `${value} - ${detailData["inquiryReasonCode"]}`}
                          {value} {section.dataPostValue}
                        </>
                      )}
                    </span>
                  </Typography>
                </Grid>
              );
            })}
          </Grid>
          <Grid
            item
            xs={2}
            className="divRequestDetail "
            marginRight={{ xs: "unset !important", md: "49px" }}
          >
            {showDoc == undefined || showDoc == true ? (
              document ? (
                <DocumentInfoComponentSingle
                  data={documentInfo}
                  accumulative={accumulative}
                  marginRight={marginRight ? marginRight : ""}
                  marginLeft={marginLeft ? marginLeft : ""}
                />
              ) : (
                <NoImageFoundDocument />
              )
            ) : null}
          </Grid>
        </Grid>
        {/* </div> */}
      </div>
    </>
  );
}
